import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { SkeletonModule } from '@syncfusion/ej2-angular-notifications';
@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [SkeletonModule,CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.css'
})
export class LoaderComponent implements OnInit {
  conicGradient: string = '';
  @Input() loading: boolean = false;
  showPieChartError: boolean = false;
  showBarChartError: boolean = false;
  showPieChartSkeleton: boolean = true;
  showBarChartSkeleton: boolean = true;
  showGridSkeleton: boolean = true;
  showGridError: boolean = false;
  @Input() type: 'grid' | 'counts' | 'piechart' | 'barchart' = 'grid';
  gridWidths: string[] = ['100%', '90%', '80%', '70%'];
  ngOnInit(): void {
    setTimeout(() => {
      if (this.type === 'grid' && this.showGridSkeleton) {
        this.showGridSkeleton = false;
        this.showGridError = true;
      }
    }, 60000);
  }
}